























import { Vue, Component } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { AxiosResponse } from 'axios';
import Topo from '../components/topology/topo.vue';
import TopoDate from '../components/topology/topo-date.vue';
import TopoAside from '../components/topology/topo-aside.vue';
import topo, { State as topoState} from '@/store/modules/topology';

@Component({components: {Topo, TopoAside, TopoDate}})
export default class Topology extends Vue {
  @State('rocketTopo') private stateTopo!: topoState;
  @Mutation('SET_EVENTS') private SET_EVENTS: any;
  @Action('rocketTopo/GET_TOPO') private GET_TOPO: any;
  @Action('rocketTopo/CLEAR_TOPO') private CLEAR_TOPO: any;
  @Action('rocketTopo/CLEAR_TOPO_INFO') private CLEAR_TOPO_INFO: any;
  @Getter('durationTime') private durationTime: any;

  private beforeMount(): void {
    this.SET_EVENTS([this.getTopo]);
  }
  private mounted() {
    this.getTopo();
  }
  private getTopo() {
    this.GET_TOPO({duration: this.durationTime});
  }
  private beforeCreate() {
    this.$store.registerModule('rocketTopo', topo);
  }
  private beforeDestroy() {
    this.CLEAR_TOPO_INFO();
    this.CLEAR_TOPO();
    this.$store.unregisterModule('rocketTopo');
  }
}

